<template>
    <transition
        name="expand-fade"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave"
        @leave="leave"
    >
        <slot />
    </transition>
</template>

<script setup>
const props = defineProps({
    expandDuration: { type: Number, default: 100 },
    fadeDuration: { type: Number, default: 200 },
});

function beforeEnter(el) {
    el.style.height = "0";
    el.style.opacity = "0";
}

function enter(el, done) {
    el.style.transition = `height ${props.expandDuration}ms ease`;
    el.style.height = el.scrollHeight + "px";

    const onHeightExpanded = () => {
        el.removeEventListener("transitionend", onHeightExpanded);
        el.style.transition = `opacity ${props.fadeDuration}ms ease`;
        el.style.opacity = "1";
        el.addEventListener("transitionend", done, { once: true });
    };

    el.addEventListener("transitionend", onHeightExpanded);
}

function beforeLeave(el) {
    el.style.height = el.scrollHeight + "px";
    el.style.opacity = "0";
}

function leave(el, done) {
    el.style.transition = `height ${props.expandDuration}ms ease`;
    el.style.height = "0";

    el.addEventListener("transitionend", done, { once: true });
}
</script>

<style scoped lang="scss">
* {
    will-change: height, opacity;
    backface-visibility: hidden;
}

.expand-fade-enter-active,
.expand-fade-leave-active {
    overflow: hidden;
}
</style>
